<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">Process Payment</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div class="modal-body">
        <div class="payment-details">
          <div class="form-group">
            <label>Amount (KES):</label>
            <input
              type="number"
              v-model="amount"
              class="form-control"
              placeholder="Enter amount"
            />
          </div>

          <div class="form-group">
            <label>Payment Method:</label>
            <select v-model="paymentMethod" class="form-control">
              <option value="" disabled>Select Method</option>

              <option value="1">Cash</option>
              <option value="3">Mpesa</option>
              <option value="2">Card</option>
            </select>
          </div>

          <!-- <div class="form-group">
            <label>Payment Note (optional):</label>
            <textarea
              v-model="note"
              class="form-control"
              rows="2"
              placeholder="Any notes..."
            ></textarea>
          </div> -->
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="confirmPayment">
          Confirm Payment
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "PaymentModal",
  props: {
    invoice_id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      amount: "",
      paymentMethod: "",
      note: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-pay-modal");
    },
    async confirmPayment() {
      if (!this.amount || !this.paymentMethod) {
        alert("Please fill in amount and payment method.");
        return;
      }
      const payload = {
        invoice_id: this.invoice_id,
        amount: this.amount,
        method: this.paymentMethod,
        note: this.note,
      };
      const url = "receive_payment/from_invoice";
      await generalApiRequest(url, "POST", payload, 1);
      this.closeModal();
    },
  },
  mounted() {
    console.log(this.patient_id);
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
}

.profile-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.profile-header img {
  border-radius: 50%;
}

.form-group {
  margin-bottom: 1rem;
}

.close {
  background: #e91616;
  border: 1px solid #b6b2b2;
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
